import { getAPIUrl } from '../../utils/getApiUrl';
import { apiLoginHanlder, apiProfileHanlder } from './auth.handlers';
import { holidaysHandlers } from './holidays.handlers';
import { ordersHandlers } from './orders.handlers';
import { usersHandlers } from './users.handlers';

export async function enableAPIMocking() {
  if (import.meta.env.VITE_E2E_TESTING !== 'TRUE') {
    return;
  }

  const { setupWorker } = await import('msw/browser');

  const browserWorker = setupWorker(
    apiProfileHanlder(),
    apiLoginHanlder(),
    ...ordersHandlers,
    ...holidaysHandlers,
    ...usersHandlers,
  );

  const API_URL = getAPIUrl();

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return browserWorker.start({
    onUnhandledRequest(request, print) {
      // Ignore unhandled requests to known hosts.
      if (!request.url.includes(API_URL)) {
        return;
      }

      print.warning();
    },
  });
}
